import { instance } from '@/app/libs/I';
import { Bitrix } from '@/app/modules/bitrix/Bitrix';
import { Request } from '@/app/modules/request/Request';
import { stringService } from '@/app/modules/string/StringService';
import { debug } from 'debug';

const localDebug = debug('app:bus:bitrixApiService');

/**
 * @deprecated legacy
 */
export namespace bitrixApiService {
  export function emailTriesRequest(id: string) {
    localDebug('emailTriesRequest', id);
    return instance(
      Request,
      stringService.replaceHolder('id', id, Bitrix.emailTriesUrl),
      Request.GET,
      Request.targets.BITRIX,
    );
  };

  export function updateEmail(id: string, newEmail: string) {
    localDebug('updateEmail', id, newEmail);
    return instance(
      Request,
      stringService.replaceHolder('id', id, Bitrix.emailUpdateUrl),
      Request.PUT,
      Request.targets.BITRIX,
      {},
      {},
      {
        change_client_email: newEmail,
      },
    );
  }

  export function sendConfirmEmail(id: string) {
    localDebug('sendConfirmEmail', id);
    return instance(
      Request,
      stringService.replaceHolder('id', id, Bitrix.emailConfirmUrl),
      Request.POST,
      Request.targets.BITRIX,
    );
  }

  export function sendConfirmCode(email: string, code: string, id: string) {
    localDebug('sendConfirmCode', email, code, id);
    return instance(
      Request,
      stringService.replaceHolder('id', id, Bitrix.codeConfirmUrl),
      Request.POST,
      Request.targets.BITRIX,
      {},
      {},
      {
        code: Number(code),
        email,
      },
    );
  }

  export function clearChangeEmail(id: string) {
    localDebug('clearChangeEmail', id);
    return instance(
      Request,
      stringService.replaceHolder('id', id, Bitrix.emailChangeClear),
      Request.POST,
      Request.targets.BITRIX,
    );
  }

  export function replaceEmail(email: string, code: string) {
    localDebug('replaceEmail', email, code);
    return instance(
      Request,
      Bitrix.replaceEmail,
      Request.PUT,
      Request.targets.BITRIX,
      {},
      {},
      {
        email,
        code,
      },
    );
  }
}
